<template lang="pug">
.shopPage

  linked-tabs.tabs
    linked-tabs-item(:to="localePath('market-index-shop-index-heroes')" :is-active="$route.name.includes('heroes')")
      span {{$t('market.tabs.gachaMint')}}
    //- linked-tabs-item(:to="localePath('market-index-shop-index-prime')" :is-active="$route.name.includes('prime')")
    //-   span {{$t('market.tabs.prime')}}
    //- linked-tabs-item(:to="localePath('market-index-shop-index-labo')" :is-active="$route.name.includes('labo')")
    //-   span {{$t('market.tabs.labo')}}
    linked-tabs-item(:to="localePath('market-index-shop-index-landvolumeshop')" :is-active="$route.name.includes('landvolumeshop')")
      span {{$t('market.tabs.landVolumeShop')}}
    linked-tabs-item(:to="localePath('market-index-shop-index-trade')" :is-active="$route.name.includes('trade')")
      span {{$t('market.tabs.trade')}}
    linked-tabs-item(:to="localePath('market-index-shop-index-exchange')" :is-active="$route.name.includes('exchange')")
      span {{$t('market.tabs.exchange')}}
    linked-tabs-item(:to="localePath('market-index-shop-index-ppdshop-index-sale')" :is-active="$route.name.includes('ppdshop')")
      span {{$t('market.tabs.ppd')}}

  //- .shopPage__links
    ul
      li
        nuxt-link(:to="localePath('market-index-shop-index-heroes')") Heroes
      li
        nuxt-link(:to="localePath('market-index-shop-index-prime')") {{ $t('pages.prime') }}
      li
        nuxt-link(:to="localePath('market-index-shop-index-rep-heroes')") Rep. Heroes

  nuxt-child

  Tokusho(v-if="!$route.name.includes('ppdshop')")

</template>

<script>
const Tokusho = () => import('@/components/atoms/Tokusho')
const LinkedTabs = () => import('@/components/organisms/LinkedTabs')
const LinkedTabsItem = () => import('@/components/molecules/LinkedTabsItem')

export default {
  components: {
    LinkedTabs,
    LinkedTabsItem,
    Tokusho,
  },
  fetch({ route, redirect }) {
    let routeName = String(route.name)
    if (
      (routeName.includes('heroes') ||
        routeName.includes('prime') ||
        routeName.includes('labo') ||
        routeName.includes('trade') ||
        routeName.includes('exchange') ||
        routeName.includes('landvolumeshop') ||
        routeName.includes('ppdshop')) == false
    )
      return redirect('/market/shop/heroes')
  },
}
</script>

<style lang="scss" scoped>
.shopPage {
  &__links {
    ul {
      display: flex;
      justify-content: space-around;
      list-style-type: none;
      margin: 1rem auto;
      max-width: 640px;
      padding: 0;

      @media (min-width: $breakpoint) {
        margin: 2rem auto;
      }
    }

    li {
      flex: 1;

      &:nth-of-type(2),
      &:nth-of-type(3),
      &:nth-of-type(4) {
        margin-left: 1rem;

        @media (min-width: $breakpoint) {
          margin-left: 2rem;
        }
      }
    }

    a {
      align-items: center;
      border: 1px solid;
      border-radius: 1rem;
      color: #ccc;
      display: flex;
      font-size: 0.75rem;
      height: 100%;
      justify-content: center;
      line-height: 1;
      padding: 0.5rem;
      text-align: center;
      text-decoration: none;

      @media (min-width: $breakpoint) {
        font-size: 1rem;
        padding: 1rem;
      }

      &.nuxt-link-active {
        border: 2px solid;
        color: #fff;
        font-weight: bold;
      }
    }
  }
}
</style>
